"use client";
import styled from "../../../client-utils/styled/index.js";
import Box from "../../../components/atoms/Box/index.js";
import CardAtom from "../../../components/atoms/Card/index.js";
import Typography from "../../../components/atoms/Typography/index.js";
import MenuList from "../../../components/atoms/MenuList/index.js";
import FloatingBadge from "../../../components/atoms/FloatingBadge/index.js";
import IconButtonAtom from "../../../components/atoms/IconButton/index.js";
import { DOUBLE, SINGLE, TRIPLE } from "../../../constants/numbers.consts.js";
const coreComponentName = "SdbCardMenu";
export const Root = styled(Box, { name: coreComponentName, slot: "Root" })();
export const Title = styled(Typography, { name: coreComponentName, slot: "Title" })(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    minHeight: 40,
    paddingLeft: theme.spacing(SINGLE),
}));
export const List = styled(MenuList, { name: coreComponentName, slot: "List" })({
    paddingTop: 0,
    paddingBottom: 0,
});
export const Badge = styled(FloatingBadge, {
    name: coreComponentName,
    slot: "Badge",
})(({ theme }) => ({
    marginLeft: theme.spacing(DOUBLE),
}));
export const IconButton = styled(IconButtonAtom, { name: coreComponentName, slot: "IconButton" })({
    marginLeft: "auto",
});
export const Card = styled(CardAtom, { name: coreComponentName, slot: "Card" })(({ theme }) => ({
    padding: theme.spacing(TRIPLE),
    border: `solid thin ${theme.vars.palette.surface.variant}`,
    borderRadius: 12,
}));
